<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right dedication-content"><b><i>To Helen – for everything.</i></b></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?b5f94550